import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';

export function trimStringControls(control: AbstractControl): void {
  if (control instanceof FormControl) {
    if (typeof control.value === 'string') {
      control.setValue(control.value.trim(), { emitEvent: false });
    }
    return;
  }

  if (control instanceof FormGroup || control instanceof FormArray) {
    Object.values(control.controls).forEach(childControl => {
      trimStringControls(childControl);
    });
  }
}
